<template>
    <div style="display: flex; flex-direction: column;">
        <MercenaryHeader v-if="step === 2" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <template v-if="step === 1">
            <div style="flex: 1; padding: 0 12px; overflow-y: scroll;">
                <div style="margin-top: 41px; text-align: center; font-size: 20px; font-weight: 500; line-height: 32px;"><span style="font-weight: 700;">{{ memberInfo.name }}</span>님이 결제를 요청했습니다.<br>결제 정보를 확인해주세요</div>
                <div style="margin-top: 21px; background: linear-gradient(90deg, rgba(255, 113, 17, 0.1) 0%, rgba(33, 15, 3, 0.1) 100%); padding: 20px 12px; border-radius: 12px;">
                    <div style=" text-align: center;">
                        <ProfileImage :imagePath="memberInfo.image_path" style="width: 80px;"></ProfileImage>
                        <div style="font-size: 14px; font-weight: 700; line-height: 24px;">{{ memberInfo.nic_name }}<span style="font-weight: 900; margin-left: 4px; font-size: 13px; color: var(--color-main);">{{ memberInfo.position }}</span></div>
                    </div>
                    <div style="border-radius: 12px; background: linear-gradient(90deg, rgba(255, 113, 17, 0.1) 0%, rgba(33, 15, 3, 0.1) 100%); padding: 12px; margin-top: 16px;">
                        <div style="font-size: 14px; font-weight: 500; line-height: 24px;">메시지 내용</div>
                        <div style="text-align: center; margin-top: 8px;">
                            <div style="font-size: 15px; line-height: 24px; font-weight: 500;">시크릿 입단 요청서를 작성하려고 합니다.</div>
                        </div>
                    </div>
                    <div style="border-radius: 12px; background: linear-gradient(90deg, rgba(255, 113, 17, 0.1) 0%, rgba(33, 15, 3, 0.1) 100%); padding: 12px; margin-top: 12px;">
                        <div style="font-weight: 700; line-height: 24px;">결제 정보</div>
                        <div style="display: flex; justify-content: space-between; margin-top: 4px;">
                            <div style="font-size: 14px; line-height: 24px; font-weight: 500;">결제 내용</div>
                            <div style="font-size: 14px; line-height: 24px; font-weight: 500;">시크릿 입단 요청서 </div>
                        </div>
                        <div style="display: flex; justify-content: space-between; margin-top: 4px;">
                            <div style="font-size: 14px; line-height: 24px; font-weight: 500;">결제 금액</div>
                            <div style="font-size: 14px; line-height: 24px; font-weight: 500;">￦{{SOCCERHOW_SECRET_REQUEST_PRICE | comma}}원</div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="step === 2">
            <div style="flex: 1; padding: 0 12px; overflow-y: scroll; display: flex; flex-direction: column; align-items: center;">
                <div style="margin-top: 20px;font-weight: 700; font-size: 20px; line-height: 32px; text-align: center;">결제 요청을 보낸분이<br>귀하의 자녀가 맞나요?</div>
                <div style="margin-top: 4px; font-weight: 700; font-size: 14px; line-height: 24px; color: var(--color-main);">APP에서 계속하기</div>
                <div style="margin-top: 20px; width: 290px; padding: 20px; border-radius: 20px; box-shadow: 0px 4px 10px 0px #210F031A; background-color: #f5f5f5;">
                    <div style=" text-align: center;">
                        <ProfileImage style="width: 80px;"></ProfileImage>
                        <div style="font-size: 14px; font-weight: 700; line-height: 24px;">{{ memberInfo.nic_name }}<span style="font-weight: 900; margin-left: 4px; font-size: 13px; color: var(--color-main);">{{ memberInfo.position }}</span></div>
                    </div>
                    <div style="border-radius: 8px; padding: 4px 12px; background-color: #fff; margin-top: 16px;">
                        <div style="font-weight: 700; font-size: 12px; line-height: 24px;">이름</div>
                        <div style="font-weight: 500; font-size: 14px; line-height: 24px;">{{ memberInfo.name }}</div>
                    </div>
                    <div style="border-radius: 8px; padding: 4px 12px; background-color: #fff; margin-top: 12px;">
                        <div style="font-weight: 700; font-size: 12px; line-height: 24px;">성별</div>
                        <div style="font-weight: 500; font-size: 14px; line-height: 24px;">{{ memberInfo.sex }}성</div>
                    </div>
                    <div style="border-radius: 8px; padding: 4px 12px; background-color: #fff; margin-top: 12px;">
                        <div style="font-weight: 700; font-size: 12px; line-height: 24px;">연락처 정보</div>
                        <div style="font-weight: 500; font-size: 14px; line-height: 24px;">{{ memberInfo.phone }}</div>
                    </div>
                    <div style="border-radius: 8px; padding: 4px 12px; background-color: #fff; margin-top: 12px;">
                        <div style="font-weight: 700; font-size: 12px; line-height: 24px;">나이</div>
                        <div style="font-weight: 500; font-size: 14px; line-height: 24px;">{{ age }}세</div>
                    </div>
                    <div style="border-radius: 8px; padding: 4px 12px; background-color: #fff; margin-top: 12px;">
                        <div style="font-weight: 700; font-size: 12px; line-height: 24px;">지역</div>
                        <div style="font-weight: 500; font-size: 14px; line-height: 24px;">{{ memberInfo.region_name }}</div>
                    </div>
                </div>
            </div>
        </template>

        <div style="background-color: #fff; height: 108px; padding: 12px;">
            <div style="display: flex; flex-direction: column;  margin-bottom: 12px;">
                <img style="width: 56px;" :src="require('@/assets/img/soccerhow_text.png')" alt="">
                <div style="font-weight: 500; font-size: 10px; line-height: 12px; margin-top: 4px; color: #606060;">사커하우 유소년 가족 인증 서비스</div>
            </div>
            <div v-if="step === 1" style="display: flex; margin-top: 12px; gap: 12px;">
                <div @click="() => { $GlobalStore.closeLastModal() }" style="border-radius: 12px; height: 48px; background-color: #ebebeb; line-height: 48px; text-align: center; font-size: 14px; font-weight: 500; flex: 1;">거절하기</div>
                <div @click="nextStep(2)" style="border-radius: 12px; height: 48px; background-color: #210f03; color: #fff; line-height: 48px; text-align: center; font-size: 14px; font-weight: 500; flex: 1;">확인 및 진행하기</div>
            </div>
            <div v-else-if="step === 2" style="display: flex; margin-top: 12px; gap: 12px;">
                <div style="border-radius: 12px; height: 48px; background-color: #ebebeb; line-height: 48px; text-align: center; font-size: 14px; font-weight: 500; flex: 1;">다른 사람입니다</div>
                <div @click="nextStep(3)" style="border-radius: 12px; height: 48px; background-color: #210f03; color: #fff; line-height: 48px; text-align: center; font-size: 14px; font-weight: 500; flex: 1; color: var(--color-main);">맞습니다</div>
            </div>
        </div>
    </div>
</template>

<script>
import ProfileImage from '@/components/common/ProfileImage'
import MercenaryHeader from '@/components/common/MercenaryHeader';
import ResponseCode from '@/ResponseCode';
import moment from 'moment';
import {SOCCERHOW_SECRET_REQUEST_PRICE} from "../../Constants";

export default {
    name: 'SecretPayRequestform',
    components: { ProfileImage, MercenaryHeader },
    props: {
        step: {
            type: Number,
            default: 1
        },
        target: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            SOCCERHOW_SECRET_REQUEST_PRICE : SOCCERHOW_SECRET_REQUEST_PRICE,
            amt: SOCCERHOW_SECRET_REQUEST_PRICE,
            memberInfo: {},
            teamInfo: {},
            moment: moment(),
            age: ''
        }
    },
    methods: {
        async payAction(pay_method, pay_mode, card_idx) {
            const parameters = {};
            parameters.pay_mode = pay_mode;
            // amt 실제결제금액
            parameters.amt = this.amt;
            parameters.goods_name = '다이렉트 요청서 보내기';
            parameters.card_idx = card_idx;
            // 해당되는 idx
            parameters.target = this.target;

            await this.$Util.payIntegrated(pay_method, parameters, async (converted_parameters) => {
                return await this.$Axios.post('/api/pay/soccerhow/secret/save/by_parent', converted_parameters);
            }, async (converted_parameters) => {
                const res = await this.$Axios.post('/api/pay/soccerhow/secret/save/by_parent', converted_parameters);
                if (res.data.code === ResponseCode.SUCCESS) {
                    // this.$GlobalStore.closeLastModal();
                    const payMethodObj = {
                        pay_method: pay_method,
                        goods_name: '시크릿 입단 요청서',
                        amt: SOCCERHOW_SECRET_REQUEST_PRICE,
                        pay_info: res.data.pay_info
                    }
                    this.$GlobalStore.addModal('CompletePayNew', { payMethodObj: payMethodObj, isModalBackTransparent: true})
                } else if (res.data.code === ResponseCode.FAIL) {
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            })
        },
        async getSoccerHowSecretRequestInfoByParent() {
            const parameters = {};
            parameters.target = this.target;

            const res = await this.$Axios.get('/api/pay/soccerhow/secret/info/by_parent', { params: parameters });
            this.memberInfo = res.data.member;
            if (this.step === 2) {
                this.age = moment().diff(moment(this.memberInfo.birthday, "YYYY-MM-DD"), "years");
            }
        },
        nextStep(step) {
            if (step === 3) {
                this.$GlobalStore.addModal('Payment', { payAction: this.payAction, goods_name: '시크릿 입단 요청서', amt: this.amt});
                return
            }
            this.$GlobalStore.addModal('SecretPayRequestform', { step: step, target: this.target })
        }
    },
    created() {
        this.getSoccerHowSecretRequestInfoByParent()
    }
}
</script>

<style scoped></style>